import { defineStore } from "pinia";

const useChatPanelFilter = defineStore("chat-panel-filter", {
  state: () => ({
    filter: {
      status: "",
      channel: [],
      business_unit: [],
      tags: [],
      ticket: [],
      room_id: "",
      sort: "",
      name: "",
      page: 1,
      per_page: 20,
      prioritize_pin: true,
      agents: [],
      broadcast: [],
      filter_unread: false,
    },
  }),
  actions: {
    setFilter(payload) {
      this.filter = payload;
    },
  },
});

export default useChatPanelFilter;
